import { Card, CardHeader, Link, makeStyles, Text, Title3 } from "@fluentui/react-components";
import { ArrowRight16Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../utils/Theme";

const useStyles = makeStyles({
    row: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "1rem",
        marginBottom: "3rem"
    },
    cardCol: {
        flex: "1 1 300px",
        maxWidth: "350px",
        width: "100%",
        padding: "0 1rem"
    },
    card: {
        display: "flex !important",
        flexDirection: "column",
        height: "100% !important",
        backgroundColor: "white !important",
        borderRadius: "8px !important",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1) !important"
    },
    header: {
        padding: "20px 20px 0 20px"
    },
    description: {
        padding: "10px 20px",
        color: "#869ab8"
    },
    learnMoreLink: {
        marginTop: 'auto !important',
        padding: '0 20px !important',
        marginBottom: '10px !important',
        color: dolphinTokens.colorLightBlue,
        display: 'inline-flex',
        alignItems: 'center',

        "& svg": {
            marginLeft: '5px',
        }
    }
});

interface IServiceCardProps {
    title: string;
    description: string;
    linkUrl: string;
    linkText: string;
}

const ServiceCard = (props: IServiceCardProps) => {
    const { title, description, linkUrl, linkText } = props;
    const { t } = useTranslation("home");
    const styles = useStyles();

    const headerText = <Title3 className={styles.header}>{title}</Title3>,
        descriptionText = <Text as="p" size={400} className={styles.description}>{description}</Text>;

    return (
        <div className={styles.cardCol}>
            <Card className={styles.card}>
                <CardHeader header={headerText} description={descriptionText} />
                <Link className={styles.learnMoreLink} href={linkUrl}>
                    <Text>
                        {linkText}
                    </Text>
                    <ArrowRight16Regular />
                </Link>
            </Card>
        </div>
    );
};

export default function KeyServices() {
    const { t } = useTranslation("home");
    const styles = useStyles();

    return (
        <div className={styles.row}>
            <ServiceCard
                title={t("keyServices.cloud.title")}
                description={t("keyServices.cloud.description")}
                linkUrl="/services/cloud"
                linkText={t("keyServices.cloud.lnkLearnMore")}
            />
            <ServiceCard
                title={t("keyServices.bps.title")}
                description={t("keyServices.bps.description")}
                linkUrl="/service/bps"
                linkText={t("keyServices.bps.lnkLearnMore")}
            />
            <ServiceCard
                title={t("keyServices.sw.title")}
                description={t("keyServices.sw.description")}
                linkUrl="/service/apps"
                linkText={t("keyServices.sw.lnkLearnMore")}
            />
        </div>
    );
}